import React from 'react';
import { Typography } from 'antd';
import { RocketOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface SidebarLogoProps {
  collapsed?: boolean;
}

export const SidebarLogo: React.FC<SidebarLogoProps> = ({
  collapsed = false,
}) => {
  return (
    <div
      style={{
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: collapsed ? 'center' : 'flex-start',
        padding: collapsed ? '0' : '0 24px',
        borderBottom: '1px solid #f0f0f0',
        background: '#ffffff',
        boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          cursor: 'pointer',
          padding: '8px',
          borderRadius: '6px',
          transition: 'all 0.2s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f5f5f5';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '32px',
            height: '32px',
            borderRadius: '6px',
            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
            boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)',
          }}
        >
          <RocketOutlined
            style={{
              fontSize: '16px',
              color: '#ffffff',
            }}
          />
        </div>
        {!collapsed && (
          <Title
            level={4}
            style={{
              margin: 0,
              color: '#1890ff',
              fontWeight: 600,
              fontSize: '18px',
              letterSpacing: '-0.5px',
            }}
          >
            Clinovia
          </Title>
        )}
      </div>
    </div>
  );
};
